export function isWeChatAuthEnabled(): boolean {
  if (window.location.pathname.startsWith('/3pl')) {
    return false
  }
  return import.meta.env.VITE_WECHAT_AUTH_ENABLED === 'true'
}
